import { styled, Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import React from "react";
import { InsightTooltipContent } from "./InsightTooltipContent";
import { InsightIcon } from "./InsightIcon";

interface InsightTooltipProps {
  insightId: string;
  showDocumentLink?: boolean;
}

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    padding: 12,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
    border: `1px solid ${theme.palette.divider}`,
    minWidth: 150,
    minHeight: 80,
  },
}));

export const InsightTooltip: React.FC<InsightTooltipProps> = ({
  insightId,
  showDocumentLink = true,
}) => {
  return (
    <StyledTooltip
      title={
        <InsightTooltipContent
          insightId={insightId}
          showDocumentLink={showDocumentLink}
        />
      }
      placement="auto"
      PopperProps={{
        modifiers: [
          {
            name: "flip",
            enabled: true,
          },
          {
            name: "preventOverflow",
            enabled: true,
            options: {
              boundary: window,
            },
          },
        ],
      }}
    >
      <span>
        <InsightIcon>i</InsightIcon>
      </span>
    </StyledTooltip>
  );
};
